import _regeneratorRuntime from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import yoda from '@ks/yoda-js-sdk';
import { computed, defineComponent, onMounted, ref } from '@vue/composition-api';
import FissionLayout from '@/pages/center/fission/components/layout.vue';
import { logger } from '@/utils/logger';
import { isIOS } from '@/utils/device';
import { jumpOneLinkForScout } from '@/utils/jump-link';
import { formatNumber, formatPrice } from '@/utils/format';
import InviteeTop from './top.vue';
import { toAppLogin } from '@/utils/outside-login';
import MyFooter from '@/pages/center/components/footer/index.vue';
import { sendFissionCustomLog } from '@/utils/custom-log';
import i18n from './k18n';
export default defineComponent({
  components: {
    FissionLayout: FissionLayout,
    InviteeTop: InviteeTop,
    MyFooter: MyFooter
  },
  setup: function setup(props, ctx) {
    var searchParams = new URL(window.location.href).searchParams;
    var inviterName = decodeURIComponent(searchParams.get('inviterName') || '');
    var referralOfficerFans = formatNumber(parseInt(searchParams.get('referralOfficerFans') || ''));
    var currencySymbol = searchParams.get('currencySymbol');
    var estimatedAward = formatPrice(parseInt(searchParams.get('estimatedAward') || ''));
    var ua = window.navigator.userAgent;
    var isIOSDevice = isIOS(ua);
    var bucket = searchParams.get('shareBucket') || '';
    var benefitConfig = [{
      key: 0,
      img: './imgs/cash_prize.png',
      titleKey: ctx.root.$t('creator_scout_invitee_cash_bonus'),
      descriptionKey: ctx.root.$t('creator_scout_invitee_cash_bonus_desc', {
        'A': currencySymbol,
        0: estimatedAward
      })
    }, // {
    //     key: 1,
    //     img: './imgs/traffic_support.png',
    //     titleKey: ctx.root.$t('creator_scout_invitee_traffic_support'),
    //     descriptionKey: ctx.root.$t('creator_scout_invitee_traffic_support_desc'),
    // },
    // {
    //     key: 2,
    //     img: './imgs/recomendation.png',
    //     titleKey: ctx.root.$t('creator_scout_invitee_more_chance'),
    //     descriptionKey: ctx.root.$t('creator_scout_invitee_more_chance_desc'),
    // },
    {
      key: 3,
      img: './imgs/creator_academy.png',
      titleKey: ctx.root.$t('creator_scout_invitee_creator_academy'),
      descriptionKey: ctx.root.$t('creator_scout_invitee_creator_academy_desc')
    }, {
      key: 4,
      img: './imgs/certification.png',
      titleKey: ctx.root.$t('creator_scout_invitee_certification'),
      descriptionKey: ctx.root.$t('creator_scout_invitee_certification_desc')
    }, {
      key: 5,
      img: './imgs/pendants.png',
      titleKey: ctx.root.$t('creator_scout_invitee_creator_pendant'),
      descriptionKey: ctx.root.$t('creator_scout_invitee_creator_pendant_desc')
    }, {
      key: 6,
      img: './imgs/levles.png',
      titleKey: ctx.root.$t('creator_scout_invitee_creator_level'),
      descriptionKey: ctx.root.$t('creator_scout_invitee_creator_level_desc')
    }, {
      key: 7,
      img: './imgs/operation.png',
      titleKey: ctx.root.$t('creator_scout_invitee_operating_personnel'),
      descriptionKey: ctx.root.$t('creator_scout_invitee_operating_personnel_desc')
    }, {
      key: 8,
      img: './imgs/vip.png',
      titleKey: ctx.root.$t('creator_scout_invitee_customer_service'),
      descriptionKey: ctx.root.$t('creator_scout_invitee_customer_service_desc')
    }];
    var descriptionText = [ctx.root.$t('creator_scout_invitee_down_sing_app'), ctx.root.$t('creator_scout_invitee_off_site_information', {
      0: referralOfficerFans
    }), ctx.root.$t('creator_scout_invitee_to_complete_task')];

    if (isIOSDevice) {
      descriptionText.push(ctx.root.$t('creator_scout_only_android'));
    }

    var handleClose = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return yoda.ready();

              case 2:
                yoda.webview.backOrClose();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function handleClose() {
        return _ref.apply(this, arguments);
      };
    }();

    var popupRef = ref(null);
    var faqIconRef = ref(null);
    var showTips = ref(true);
    var popupTop = ref(0);

    var handleFaqClick = function handleFaqClick() {
      showTips.value = true;
      setTimeout(function () {
        showTips.value = false;
      }, 3000);
    };

    onMounted(function () {
      // popupTop.value = (popupRef.value as HTMLElement)[0].clientHeight + 14;
      setTimeout(function () {
        showTips.value = false;
      }, 3000);
    });

    var handleBtnClick = function handleBtnClick() {
      logger.kwailog.sendClick({
        action: 'DOWNLOAD_THE_APP'
      });
      sendFissionCustomLog({
        event: 'clickToDownload'
      });
      var share_uid = new URL(location.href).searchParams.get('share_uid');
      var referUrl = new URL("".concat(window.location.origin, "/creator/center/fission/sign"));
      referUrl.searchParams.set('bizId', 'creative');
      referUrl.searchParams.set('share_uid', share_uid || '');

      if (isIOSDevice) {
        // 跳转到端内去登录,referUrl是最终跳到授权登录后重新跳到端外的链接
        toAppLogin(referUrl.href);
      } else {
        jumpOneLinkForScout(referUrl.href);
      }
    };

    var footerDesc = computed(function () {
      var text = i18n.t('creator_fission_ios_not_open');
      var inner0HTML = "<strong\n                    >".concat(i18n.t('creator_fission_ios_collect'), "</strong>");
      text = text.replace('{0}', inner0HTML);
      return text;
    });
    return {
      popupTop: popupTop,
      showTips: showTips,
      handleClose: handleClose,
      descriptionText: descriptionText,
      benefitConfig: benefitConfig,
      popupRef: popupRef,
      handleFaqClick: handleFaqClick,
      handleBtnClick: handleBtnClick,
      inviterName: inviterName,
      referralOfficerFans: referralOfficerFans,
      currencySymbol: currencySymbol,
      estimatedAward: estimatedAward,
      isIOSDevice: isIOSDevice,
      footerDesc: footerDesc
    };
  }
});